import { graphql, useStaticQuery } from "gatsby";
import React from "react";

export const HeadMeta = ({ title = "", description = "", children }) => {
	const {
		title: titleBase,
		description: defaultDescription,
		image,
		icon,
		siteUrl,
	} = useSiteMetadata();

	const pageTitleFull = (title !== "" ? `${title} — ` : ``) + titleBase;
	const finalDescription =
		description !== "" ? description : defaultDescription;

	return (
		<>
			<title>{pageTitleFull}</title>
			<meta name="description" content={finalDescription} />
			<meta name="image" content={image} />
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={pageTitleFull} />
			<meta name="twitter:url" content={siteUrl} />
			<meta name="twitter:description" content={finalDescription} />
			<meta name="twitter:image" content={image} />
			<link rel="icon" href={icon} />

			<link rel='preconnect' href='https://fonts.googleapis.com' crossOrigin="true" />
			<link rel='preload' href='https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&display=swap' crossOrigin="true" />
		</>
	);
};

export const useSiteMetadata = () => {
	const data = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					title
					description
					image
					icon
					siteUrl
				}
			}
		}
	`);

	return data.site.siteMetadata;
};
